import React from 'react'
import { Link } from "react-router-dom"
import Pagination from '../../../common/reactPaginate';
import { getLabel } from '../../../common/getLabel';
import { baseUrl } from '../../common/config';
import { getUserProfileStyles } from '../../../common/common';
import ProfileSkeletonFrontSideLoading from '../../common/skeleton-loading/profile-skeleton-loading-frontend';
const Listing = (props) => {
    const { error, profiles, loading, totalCount, currentPage, limit, handlePaginate, show_top_200, filterdata } = props;
    const handlePageClick = (selectedPage) => {
        handlePaginate(selectedPage);
    };
    const totalPages = Math.ceil(totalCount / limit);
    const calculateSerialNumber = (index) => (currentPage - 1) * limit + index + 1;
    return (
        <>
            <div className="row news-detail-space">
                {loading ? (
                    <ProfileSkeletonFrontSideLoading length={limit} />
                ) : error ? (
                    <h3 style={{ textAlign: "center" }}>
                        {getLabel("LBL_Some_thing_wrong_Please_try_again_later")}
                    </h3>
                ) : (
                    <>
                        {profiles && profiles.length > 0 ? (
                            profiles.map((profile, index) => {
                                const school = (profile.school) ? JSON.parse(profile.school) : '';
                                const height_feet = (profile.height_feet) ? JSON.parse(profile.height_feet) : '';
                                const height_inch = (profile.height_inch) ? JSON.parse(profile.height_inch) : '';
                                const weight = (profile.weight) ? JSON.parse(profile.weight) : '';
                                const hs_name = (school && school.hs_name) ? school.hs_name : '';
                                const hs_state = (school && school.hs_state) ? school.hs_state : '';
                                let stats = '';
                                if (height_feet !== '' && height_inch !== '') {
                                    stats = `${height_feet}'${height_inch}"`;
                                }
                                if (weight) {
                                    stats += `  ${weight} lbs.`;
                                }
                                let starsRating = 0;
                                let profileScore = 0;
                                if (profile.uprofile_style === 3 || profile.uprofile_style === 4) {
                                    starsRating = (profile.wr_te_stars) ? (profile.wr_te_stars * 100) / 5 : 0;
                                    profileScore = profile.uprofile_wr_te_final
                                } else {
                                    starsRating = (profile.stars) ? (profile.stars * 100) / 5 : 0;
                                    profileScore = profile.uprofile_eval_final
                                }
                                let rank;
                                if(show_top_200){
                                    // if(filterdata.keyword != ''){
                                        if(profile.rank){
                                            rank = `# ${profile.rank}`;
                                        }
                                    // }else{
                                    //     rank = `# ${calculateSerialNumber(index)}`
                                    // }
                                }
                                return (
                                    <div className="col-lg-12 col-sm-6" key={index}>
                                        <div className="qbh-player-list-box">
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="player-profile-pics">
                                                        <figure>
                                                            <Link to={`/profile/${profile["profileUrl.urlrewrite_custom"]}`}>
                                                                <img
                                                                    src={profile.images && profile.images[0] && profile.images[0].afile_physical_path ? `${baseUrl}/${profile.images[0].afile_physical_path}` : "/images//qbh-hit.jpg"}
                                                                    className="img-fluid"
                                                                    alt={profile.images && profile.images[0] && profile.images[0].afile_name ? profile.images[0].afile_name : profile.uprofile_fname}
                                                                />
                                                            </Link>
                                                        </figure>
                                                        <div className="player-pro-name a"><Link to={`/profile/${profile["profileUrl.urlrewrite_custom"]}`}><h5>{rank} {profile.uprofile_fname} {profile.uprofile_lname}</h5></Link></div>
                                                    </div>
                                                    <div className="line-player"></div>
                                                </div>

                                                <div className="col col-lg-4 col-sm-4 box-padding-left">
                                                    <div className="school-list">
                                                        <ul className="border-dashd-right">
                                                            <li className="bold">{hs_name}</li>
                                                            <li className="bold">{getLabel('LBL_State:')} {hs_state} </li>
                                                            <li className="bold">{getLabel('LBL_Class:')} {profile.uprofile_grad_class}</li>
                                                            <li className="bold">{getLabel('LBL_Style:')} {getUserProfileStyles[profile.uprofile_style]} </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div className="col col-lg-4 col-sm-4 box-padding-right">
                                                    <div className="school-list">
                                                        <ul>
                                                            <li>{getLabel('LBL_Height/Weight:')} {stats} </li>
                                                            <li>{getLabel('LBL_Score:')} {profileScore}</li>
                                                            {starsRating ? (
                                                                <li>
                                                                    <div className="review__rating star-rating-menu">
                                                                        <div className="icn" style={{ width: starsRating + '%' }}></div>
                                                                    </div>
                                                                </li>
                                                            ) : (
                                                                <>
                                                                    {getLabel('LBL_Not_Yet_Rated')}
                                                                </>
                                                            )}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        ) : (
                            <h4 className="my-4" style={{ textAlign: "center" }}>
                                {getLabel("LBL_No_result_found")}
                            </h4>
                        )}
                    </>
                )}
                {profiles && profiles.length > 0 && (
                    <>
                        <div className="col-lg-12">
                            <div className="custom-pagination">
                                <nav aria-label="...">
                                    <Pagination totalPages={totalPages} handlePageClick={handlePageClick} currentPage={currentPage} />
                                </nav>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
}

export default Listing
